import React from 'react';
import { Link } from 'react-router-dom';
import { env } from '../../config/env';

export const Footer: React.FC = () => {
    return (
        <footer className="bg-white dark:bg-background-dark border-t border-gray-200 dark:border-gray-800 pt-16 pb-8">
            <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10 mb-16">
                    <div className="col-span-2">
                        <div className="flex items-center gap-3 mb-6">
                            {env.LOGO_URL ? (
                                <img src={env.LOGO_URL} alt={env.COMPANY_NAME} className="size-8 rounded-lg object-cover" />
                            ) : (
                                <div className="size-8 bg-primary rounded-lg flex items-center justify-center text-white">
                                    <span className="material-symbols-outlined">shopping_bag</span>
                                </div>
                            )}
                            <h2 className="text-xl font-bold tracking-tight uppercase">{env.COMPANY_NAME}</h2>
                        </div>
                        <p className="text-gray-500 dark:text-gray-400 max-w-xs leading-relaxed">
                            Curating the world's most premium essentials for a refined lifestyle. Quality first, always.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-bold mb-6">Shop</h4>
                        <ul className="space-y-4 text-sm text-gray-500 dark:text-gray-400">
                            <li><Link className="hover:text-primary transition-colors" to="/products">All Products</Link></li>
                            <li><Link className="hover:text-primary transition-colors" to="/categories">Categories</Link></li>
                            <li><Link className="hover:text-primary transition-colors" to="/best-sellers">Best Sellers</Link></li>
                            <li><Link className="hover:text-primary transition-colors" to="/gift-cards">Gift Cards</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-bold mb-6">Support</h4>
                        <ul className="space-y-4 text-sm text-gray-500 dark:text-gray-400">
                            <li><Link className="hover:text-primary transition-colors" to="/shipping">Shipping Policy</Link></li>
                            <li><Link className="hover:text-primary transition-colors" to="/refunds">Refunds & Returns</Link></li>
                            <li><Link className="hover:text-primary transition-colors" to="/track">Track Order</Link></li>
                            <li><Link className="hover:text-primary transition-colors" to="/contact">Contact Us</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold mb-6">Connect</h4>
                        <div className="flex gap-4 mb-4">
                            <a className="size-8 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800 hover:text-primary transition-colors" href="#">
                                <span className="material-symbols-outlined text-sm">public</span>
                            </a>
                            <a className="size-8 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800 hover:text-primary transition-colors" href="#">
                                <span className="material-symbols-outlined text-sm">share</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="border-t border-gray-100 dark:border-gray-800 pt-8 flex flex-col md:row items-center justify-between gap-4">
                    <p className="text-xs text-gray-400">© 2024 {env.COMPANY_NAME} E-commerce. All rights reserved.</p>
                    <div className="flex gap-6 text-xs text-gray-400">
                        <Link className="hover:underline" to="/privacy">Privacy Policy</Link>
                        <Link className="hover:underline" to="/terms">Terms of Service</Link>
                        <Link className="hover:underline" to="/cookies">Cookie Settings</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};
